import { Form as ANTDForm, Radio } from 'antd'
import { COLORS } from 'constants/colors'
import styled, { css } from 'styled-components'

export const Form = styled(ANTDForm)`
  width: 100%;
`

export const FormItem = styled(ANTDForm.Item)<{ isButton?: boolean }>`
  ${({ isButton }) =>
    isButton &&
    css`
      .ant-form-item-control,
      .ant-input-affix-wrapper,
      .ant-input {
        background-color: #ffffff;
        color: ${COLORS.text.default};
        cursor: pointer;
      }
      .ant-input,
      .ant-input-affix-wrapper {
        &:hover {
          border-color: #239cd9;
          border-inline-end-width: 1px;
        }
      }
    `}

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  &:last-child {
    margin: 0;
  }
`

export const RadioGroup = styled(Radio.Group)`
  &.ant-radio-group {
    display: flex;
    align-items: center;
  }

  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none;
  }

  .ant-radio-button-wrapper {
    width: 100%;

    font-weight: 600;
    font-size: 14px;
    color: ${COLORS.text.default};
    text-align: center;

    border: 1px solid #d2dde2;
    border-radius: 40px;

    &:hover {
      border-color: ${COLORS.primary.medium};
    }

    &:first-child {
      margin-right: 12px;
    }

    &.ant-radio-button-wrapper-checked {
      color: #ffffff;
      background-color: ${COLORS.primary.medium};
      border-color: ${COLORS.primary.medium};
    }
  }
`
